import { Box, Skeleton } from '@redbubble/design-system';
import { AppProps, DeviceType } from '@redbubble/next/types';
import { usePageProps } from '@redbubble/next-provider';
import styles from './SearchHeader.module.scss';

export const HeroTextHeaderLoading: React.FC = () => {
  const { deviceType } = usePageProps<AppProps>();

  return (
    <Box className={styles.outerContainer}>
      <Box className={styles.titleContainer}>
        <Box marginY="xxs">
          <Skeleton
            animated
            width={deviceType === DeviceType.Desktop ? '30%' : '50%'}
            height={32}
            data-testid="hero-title-skeleton"
          />
        </Box>
        <Box className={styles.pitch}>
          <Skeleton animated height={24} data-testid="hero-pitch-skeleton" />
        </Box>
      </Box>
    </Box>
  );
};

export const HeroImageHeaderLoading: React.FC = () => {
  return (
    <Box marginTop="m">
      <Skeleton animated height={230} data-testid="hero-image-skeleton" />
    </Box>
  );
};

export const FallbackHeaderLading: React.FC = () => {
  const { deviceType } = usePageProps<AppProps>();

  return (
    <Box className={styles.outerContainer}>
      <Box className={styles.titleContainer}>
        <Skeleton
          animated
          width={deviceType === DeviceType.Desktop ? '30%' : '50%'}
          height={32}
          data-testid="fallback-search-title-skeleton"
        />
      </Box>
    </Box>
  );
};
